import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useState } from "react";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import eye from "../assets/images/icons/eye.svg";
import eyeslash from "../assets/images/icons/eye-slash.svg";
import logo from "../assets/logo/Logo.svg";
import google from "../assets/logo/Google.svg";
import facebook from "../assets/logo/Facebook.svg";
import apple from "../assets/logo/apple.png";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import Carousel from "../components/carousel/logincarousel";
import profileimg from "../assets/profile.png";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export default function Login() {
  const location = useLocation();

  // State for email and password
  const [email, setEmail] = useState(() =>
    localStorage.getItem("rememberMe") === "true"
      ? localStorage.getItem("rememberedEmail") || ""
      : ""
  );
  const [password, setPassword] = useState(() =>
    localStorage.getItem("rememberMe") === "true"
      ? localStorage.getItem("rememberedPassword") || ""
      : ""
  );
  const [error, setError] = useState("");
  const [token, setToken] = useState("");
  const [userData, setUserData] = useState(null);
  const [showPassword, setShowPassword] = useState(false); // 👁️ Toggle password visibility
  const [rememberMe, setRememberMe] = useState(
    () => localStorage.getItem("rememberMe") === "true"
  );


  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate(); // Navigation hook

  const API_URL = `${API_BASE_URL}/auth`;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Reset previous errors
    let newErrors = {
      email: "",
      password: "",
      api: "",
    };

    // ✅ Frontend validation
    if (!email.trim()) {
      newErrors.email = "Please enter your email.";
    }

    if (!password.trim()) {
      newErrors.password = "Please enter your password.";
    }

    // Set validation errors
    setErrors(newErrors);

    // ⛔ Stop if validation fails
    if (newErrors.email || newErrors.password) return;

    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: {
          token: `${sessionStorage.getItem("accessToken") ||
            localStorage.getItem("accessToken")
            }`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        if (rememberMe) {
          localStorage.setItem("rememberedEmail", email);
          localStorage.setItem("rememberedPassword", password);
          localStorage.setItem("rememberMe", "true");
        } else {
          localStorage.removeItem("rememberedEmail");
          localStorage.removeItem("rememberedPassword");
          localStorage.removeItem("rememberMe");
        }

        const profilePictureUrl =
          data.result.profile_picture_url || profileimg;
        sessionStorage.setItem("profilePictureUrl", profilePictureUrl);
        localStorage.setItem("profilePictureUrl", profilePictureUrl);

        sessionStorage.setItem("user", JSON.stringify(data.result));
        localStorage.setItem("user", JSON.stringify(data.result));

        sessionStorage.setItem("accessToken", data.result.token);
        localStorage.setItem("accessToken", data.result.token);

        console.log("Login Success:", data);

        const from = location.state?.from?.pathname || "/";
        navigate(from, { replace: true });

        localStorage.setItem("user", JSON.stringify(data.result));

        const token = data.result.token.access.token;
        localStorage.setItem("authToken", token);

        const accessToken = data.result.token?.refresh?.token;
        console.log("Access Token:", accessToken);

        sessionStorage.setItem("accessToken", accessToken);
        localStorage.setItem("accessToken", accessToken);

        console.log(
          "Stored Token:",
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken")
        );

        // ✅ Store user details
        const user = data.result?.user;

        if (user) {
          sessionStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("user", JSON.stringify(user));
          sessionStorage.setItem("userID", user.id);
          localStorage.setItem("userID", user.id);

          console.log(
            "User Data Stored:",
            sessionStorage.getItem("user") ||
            localStorage.getItem("user")
          );
          console.log("User ID Stored:", sessionStorage.getItem("userID"));
        } else {
          console.error("User data is missing in response");
        }

        // 🔔 Notify other components
        const event = new CustomEvent("profilePictureUpdated");
        window.dispatchEvent(event);

        // 🚀 Redirect
        navigate("/home");
      } else {
        setErrors((prev) => ({
          ...prev,
          api: data.message || "Invalid credentials. Please try again.",
        }));
      }
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        api: "Something went wrong. Please try again later.",
      }));
      console.error("Login Error:", err);
    }
  };


  // ✅ Handle Google Login
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/google`;
  };
  // const fetchUserProfile = async () => {
  //   const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve token
  //   console.log("Retrieved Token in home page:", token); // ✅ Log token to verify

  //   if (!token) {
  //     console.log("Token not found, waiting...");
  //     setError("Authentication token not found!");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/user/profile`,
  //       {
  //         method: "GET",
  //         headers: {
  //           token: `${token}`, // ✅ Ensure proper format
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("API Response Status:", response.status); // ✅ Log status
  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       console.error("❌ API Error Data:", errorData);
  //       setError(errorData.message || "Failed to fetch user profile");
  //       return;
  //     }

  //     const data = await response.json();
  //     console.log("✅ API Success Response from profile page:", data); // ✅ Log full response
  //     setUserData(data.result);
  //     sessionStorage.setItem("user", JSON.stringify(data.result)); // Store user in sessionStorage
  //   } catch (err) {
  //     console.error("❌ Fetch API Error:", err);
  //     setError("An error occurred while fetching the profile");
  //   }
  // };
  // useEffect(() => {
  //   // ✅ Parse URL query parameters
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const success = urlParams.get("success");
  //   const token = urlParams.get("token");
  //   // const user = urlParams.get("user");

  //   console.log("Google Login Response:", { success, token });

  //   if (success === "true" && token) {
  //     setToken(token);
  //     sessionStorage.setItem("accessToken", token);

  //     // sessionStorage.setItem("user", decodeURIComponent(user));
  //     fetchUserProfile();
  //     // console.log("User Data:", decodeURIComponent(user));
  //     if (sessionStorage.getItem("user") || localStorage.getItem("user")) {
  //       navigate("/home");
  //     }
  //   } else {
  //     console.error("Google Login Failed");
  //     // navigate("/");
  //   }
  // }, [userData]);

  // ✅ Handle Facebook Login


  // ...existing code...

  // fetch user profile (accept optional token to use immediately after OAuth)
  const fetchUserProfile = async (providedToken) => {
    const tk = providedToken || sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!tk) {
      console.warn("Token not found for fetchUserProfile");
      return null;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/user/profile`,
        {
          method: "GET",
          headers: {
            token: `${tk}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error("Profile fetch error:", errorData);
        return null;
      }

      const data = await response.json();
      // persist user + token
      setUserData(data.result);
      sessionStorage.setItem("user", JSON.stringify(data.result));
      localStorage.setItem("user", JSON.stringify(data.result));
      return data.result;
    } catch (err) {
      console.error("fetchUserProfile error:", err);
      return null;
    }
  };

  // handle OAuth callback once on mount: await profile fetch then navigate
  useEffect(() => {
    const handleOAuthCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const success = params.get("success");
      const tokenParam = params.get("token");

      if (success === "true" && tokenParam) {
        // store token immediately
        sessionStorage.setItem("accessToken", tokenParam);
        localStorage.setItem("accessToken", tokenParam);
        setToken(tokenParam);

        // wait for profile fetch to complete
        const profile = await fetchUserProfile(tokenParam);
        if (profile) {
          // remove query params from URL without reloading
          try {
            window.history.replaceState({}, document.title, window.location.pathname);
          } catch (e) {
            /* ignore */
          }
          navigate("/home", { replace: true });
        } else {
          console.error("Failed to fetch profile after OAuth callback");
        }
      }
    };

    handleOAuthCallback();
    // run once
  }, []);
  // ...existing code...  

  const handleFacebookLogin = () => {
    window.location.href = `${API_URL}/facebook`;
  };

  // Carousel login
  let slides = [loginbanner, loginbannertwo, loginbannerthree, loginbannerfour];
  let slidessm = [loginbannersm, loginbannersm, loginbannersm, loginbannersm];

  return (
    <div className="login">
      <div className="container min-h-screen flex">
        {/* Left side image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3 ">
            <Carousel slides={slides} />
            {/* <!-- Overlay Image --> */}
            <img src={bannerlayout} alt="Overlay" class="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>

        {/* Right side login form */}
        <div className=" w-full lg:w-1/2 login-content flex flex-col">
          <div className="carousel-d-none-sm md:block lg:hidden ">
            <div className="carousel-size pb-3 pt-3 ">
              <Carousel slides={slides} />
              {/* <!-- Overlay Image --> */}
              <img src={bannerlayout} alt="Overlay" class="layout" />
            </div>
          </div>
          <div className="lg:hidden md:hidden">
            <div className="carousel-size pb-3 pt-3 ">
              <Carousel slides={slidessm} />
              {/* <!-- Overlay Image --> */}
              <img src={bannerlayout} alt="Overlay" class="layout" />
            </div>
          </div>
          <div className="login-form">
            {/* Language selector */}
            <div className="flex justify-end">
              <Menu
                as="div"
                className="language-btn relative inline-block text-left"
              >
                <div>
                  {/* <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm align-center  hover:bg-gray-50">
                    English
                    <svg width="10" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.92 0.179932H6.68999H1.07999C0.119992 0.179932 -0.360007 1.33993 0.319993 2.01993L5.49999 7.19993C6.32999 8.02993 7.67999 8.02993 8.50999 7.19993L10.48 5.22993L13.69 2.01993C14.36 1.33993 13.88 0.179932 12.92 0.179932Z" fill="#292D32" />
                    </svg>
                  </MenuButton> */}
                </div>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >
                        {" "}
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      ></a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      ></a>
                    </MenuItem>
                    <form action="#" method="POST">
                      <MenuItem>
                        <button
                          type="submit"
                          className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                        ></button>
                      </MenuItem>
                    </form>
                  </div>
                </MenuItems>
              </Menu>
            </div>

            {/* Main content */}
            <div className="flex-1 flex flex-col items-center justify-center max-w-[440px] mx-auto w-full">
              {/* Logo */}
              <div className="mb-8">
                <img src={logo} alt="Pipaan Logo" width={150} height={50} />
              </div>

              {/* Login form */}
              <form onSubmit={handleSubmit} className="login-form-content">
                <h1 className="login-title text-2xl font-semibold text-center mb-5">
                  Login Your Account
                </h1>
                <div className="space-y-4">
                  <div className="flex flex-col space-y-2">
                    <label className="text-sm font-medium" htmlFor="email">
                      Email
                    </label>

                    <input
                      id="email"
                      placeholder="Enter your E Mail ID"
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrors((prev) => ({ ...prev, email: "", api: "" }));
                      }}
                      className={`h-[56px] px-3 py-2 border rounded-lg outline-none
                      ${errors.email
                          ? "border-red-500 focus:ring-2 focus:ring-red-200"
                          : "border-gray-300 focus:ring-2 focus:ring-[#00000014]"
                        }
                          focus:ring-offset-0
                        `}
                    />

                    {errors.email && (
                      <p className="text-sm text-red-500">{errors.email}</p>
                    )}
                  </div>

                  {/* {error && <p className="error-message text-red-500">{error}</p>}{" "} */}
                  <div className="flex flex-col space-y-2 relative">
                    <label className="text-sm font-medium" htmlFor="password">
                      Password
                    </label>

                    <div className="relative w-full">
                      <input
                        id="password"
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setErrors((prev) => ({ ...prev, password: "", api: "" }));
                        }}
                        className={`h-[56px] w-full px-3 py-2 border rounded-lg outline-none
                          ${errors.password
                            ? "border-red-500 focus:ring-2 focus:ring-red-200"
                            : "border-gray-300 focus:ring-2 focus:ring-[#00000014]"
                          }
                          focus:ring-offset-0
                        `}
                      />

                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-4 top-1/2 -translate-y-1/2 z-10"
                      >
                        <img
                          src={showPassword ? eye : eyeslash}
                          alt="Toggle Password"
                          className="w-6 h-6"
                        />
                      </button>
                    </div>

                    {errors.password && (
                      <p className="text-sm text-red-500">{errors.password}</p>
                    )}

                    {errors.api && (
                      <p className="text-sm text-red-500 mt-2">{errors.api}</p>
                    )}
                  </div>

                </div>

                <div className="mt-4 mb-8 flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    {/* <input
                      type="checkbox"
                      id="remember"
                      className="w-4 h-4 chk-box  text-black-600 border-gray-300 rounded focus:ring-blue-500 border-2 border-blue-500 rounded-sm bg-white"
                    /> */}
                    <div class="inline-flex items-center">
                      <label class="flex items-center cursor-pointer relative">
                        <input
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                          type="checkbox"
                          class="chk-box peer h-6 w-6 cursor-pointer transition-all appearance-none rounded-full bg-white-100 shadow hover:shadow-md border border-black-300 checked:bg-white-800 checked:border-slate-800"
                          id="remember"
                        />
                        <span class="absolute text-black opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-3.5 w-3.5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            stroke="currentColor"
                            stroke-width="1"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </span>
                      </label>
                    </div>
                    <label
                      htmlFor="remember"
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      Remember Me
                    </label>
                  </div>
                  <a
                    href="/forgotpassword"
                    className="text-sm  text-[#095228] hover:underline font-medium"
                  >
                    Forgot Password
                  </a>
                </div>
                <button
                  type="submit"
                  className="submit-btn bg-[#161F28] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl"
                >
                  Login
                </button>
                <div className="relative mt-6 mb-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t-2 border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-[#FAFAFA] px-2 text-gray-500 ">Or</span>
                  </div>
                </div>

                <div className="flex login-form-content space-y-2 relative">
                  <button
                    type="submit"
                    onClick={() => navigate("/signinwithmobile")}
                    className="submit-btn bg-[#161F28] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl"
                  >
                    Login with Mobile Number
                  </button>
                </div>
                <div className="relative mt-8 mb-4 ">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t-2 border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-[#FAFAFA] px-2 text-gray-500 ">
                      Or continue with
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-10">
                  <button
                    className="w-full rounded-lg p-2"
                    onClick={handleGoogleLogin}
                  >
                    <img src={google} alt="Google" className=" mx-auto" />
                  </button>
                  <button
                    className="w-full rounded-lg p-2"
                    onClick={handleFacebookLogin}
                  >
                    <img src={facebook} alt="Facebook" className=" mx-auto" />
                  </button>
                </div>
              </form>
              <p className=" text-center text-sm text-[#122B31] mt-4">
                Don't you have an account?{" "}
                <a
                  href="/signup"
                  className="text-[#006838] hover:underline font-semibold"
                >
                  Create New Account
                </a>
              </p>
            </div>

            {/* Footer */}
            <div className="lg:hidden">
              <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                © 2025 Pipaan. All Rights Reserved
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
